// Bundle Cascade NACA — suppression atomique casque + liner NACA (un seul appel /cart/update.js).
//
// bundle-cascade.js (partagé, utilisé aussi par Samshield) retire le casque puis le liner via
// 2 appels /cart/change.js séquentiels. Pour NACA, le liner est un vrai produit remis à 0€ par une
// remise auto "Buy X Get Y" : retirer le casque en premier fait recalculer cette remise côté
// Shopify entre les deux appels, ce qui fait échouer le 2e (400) et laisse le liner orphelin dans
// le panier. Ce fichier ne modifie rien à bundle-cascade.js — il agit uniquement sur les lignes
// marquées `_bundle_type: 'naca'` (posées par assets/bundle-casque-naca.js à l'ajout au panier) et
// laisse tout le reste (Samshield compris) passer normalement à bundle-cascade.js, inchangé.
//
// Chargé AVANT bundle-cascade.js dans layout/theme.liquid pour s'attacher en premier sur les liens
// de suppression : sur une ligne NACA, stopImmediatePropagation empêche bundle-cascade.js (et le
// script de cascade dupliqué dans line-item.liquid) de s'exécuter aussi sur le même clic.

(function() {

  var nacaHelmetToLiner = {};

  function refreshNacaMap() {
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var map = {};
        var liner = cart.items.find(function(item) {
          var props = item.properties || {};
          return props['_bundle_liner'] === 'true' && props['_bundle_type'] === 'naca';
        });
        cart.items.forEach(function(item) {
          var props = item.properties || {};
          if (props['_bundle_type'] === 'naca' && props['_bundle_liner'] !== 'true') {
            map[item.key] = liner ? liner.key : null;
          }
        });
        nacaHelmetToLiner = map;
      })
      .catch(function() { nacaHelmetToLiner = {}; });
  }

  function initCascadeNaca() {
    var removeLinks = document.querySelectorAll('[data-remove-line-key]');
    removeLinks.forEach(function(link) {
      if (link.dataset.nacaCascadeInit) return;
      link.dataset.nacaCascadeInit = 'true';

      link.addEventListener('click', function(e) {
        var lineKey = link.getAttribute('data-remove-line-key');
        if (!(lineKey in nacaHelmetToLiner)) return; // pas une ligne NACA : bundle-cascade.js gère

        e.preventDefault();
        e.stopImmediatePropagation();

        var linerKey = nacaHelmetToLiner[lineKey];
        var updates = {};
        updates[lineKey] = 0;
        if (linerKey) updates[linerKey] = 0;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function() {
          if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
            window.location.reload();
            return;
          }
          return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(updatedCart) {
            var sectionsToBundle = new Set();
            document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
              bubbles: true, detail: { sections: sectionsToBundle }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'line-item:change', cart: updatedCart }
            }));
          });
        });
      });
    });
  }

  function onDomReady() {
    initCascadeNaca();
    refreshNacaMap();
  }

  document.addEventListener('DOMContentLoaded', onDomReady);
  document.addEventListener('cart:refresh', function() { setTimeout(onDomReady, 300); });
  document.documentElement.addEventListener('cart:change', function() { setTimeout(onDomReady, 300); });

})();
